// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sidebarItem_active__h9ElT {\n  background-color: rgba(144, 202, 249, 0.16) !important;\n  border-radius: 4px !important;\n}", "",{"version":3,"sources":["webpack://./src/common/components/Sidebar/SidebarItem/sidebarItem.module.css"],"names":[],"mappings":"AAAA;EACE,sDAAsD;EACtD,6BAA6B;AAC/B","sourcesContent":[".active {\n  background-color: rgba(144, 202, 249, 0.16) !important;\n  border-radius: 4px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"active": "sidebarItem_active__h9ElT"
};
export default ___CSS_LOADER_EXPORT___;
